export default __webpack_public_path__ + "static/ma-41e1dcfcdd2376fbc24313d103aa7523.svg";